// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ExplorerComparisonController from "./explorer_comparison_controller"
application.register("explorer-comparison", ExplorerComparisonController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SnapshotFormController from "./snapshot_form_controller"
application.register("snapshot-form", SnapshotFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import RichClipboardController from "./rich_clipboard_controller"
application.register("rich-clipboard", RichClipboardController)

import CopyAndOpenController from "./copy_and_open_controller"
application.register("copy-and-open", CopyAndOpenController)

import ExpandableRowController from "./expandable_row_controller"
application.register("expandable-row", ExpandableRowController)

import BuilderController from "./builder_controller"
application.register("builder", BuilderController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import LiveInputsController from "./live_inputs_controller"
application.register("live-inputs", LiveInputsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ComplianceChecksController from "./compliance_checks_controller"
application.register("compliance-checks", ComplianceChecksController)

import ExperimentalToggleController from "./experimental_toggle_controller"
application.register("experimental-toggle", ExperimentalToggleController)

import InboxRowController from "./inbox_row_controller"
application.register("inbox-row", InboxRowController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import PrivacyModeController from "./privacy_mode_controller"
application.register("privacy-mode", PrivacyModeController)

import CashFlowFormController from "./cash_flow_form_controller"
application.register("cash-flow-form", CashFlowFormController)

import ManualAssetFormController from "./manual_asset_form_controller"
application.register("manual-asset-form", ManualAssetFormController)

import CodeCopyController from "./code_copy_controller"
application.register("code-copy", CodeCopyController)

import SubmitFeedbackController from "./submit_feedback_controller"
application.register("submit-feedback", SubmitFeedbackController)

import StrategyEditorController from "./strategy_editor_controller"
application.register("strategy-editor", StrategyEditorController)

import HeadingAnchorsController from "./heading_anchors_controller"
application.register("heading-anchors", HeadingAnchorsController)

import FaqFilterController from "./faq_filter_controller"
application.register("faq-filter", FaqFilterController)

import TrackRecordTooltipController from "./track_record_tooltip_controller"
application.register("track-record-tooltip", TrackRecordTooltipController)

import AgentPickerController from "./agent_picker_controller"
application.register("agent-picker", AgentPickerController)

import ClampController from "./clamp_controller"
application.register("clamp", ClampController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import WorkspaceStatusController from "./workspace_status_controller"
application.register("workspace-status", WorkspaceStatusController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MembershipActivationController from "./membership_activation_controller"
application.register("membership-activation", MembershipActivationController)
